(function () {
  'use strict';

  angular.module('lead.bulk.status').factory('LeadBulkStatus', LeadBulkStatus);

  LeadBulkStatus.$inject = ['$resource'];

  function LeadBulkStatus($resource) {
    return $resource(
      '/api/',
      {},
      {
        get: {
          method: 'GET',
          url: '/api/lead/status',
          isArray: true,
          cache: true,
        },
        bulkUpdate: { method: 'POST', url: 'api/lead/bulk_statuses' },
      },
    );
  }
})();
